const tableHeader = [
   {
      Header: "",
      accessor: "sequence_no",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Application",
      accessor: "app.name",
    },
    {
      Header: "Actions",
      accessor: "actions"
    }
];

export { tableHeader };
  